import SchemaFormAutoSubmit from "@/components/Schema/SchemaFormAutoSubmit";
import { PageHeader } from "@ant-design/pro-components";
import { createForm } from "@formily/core";
import { Button, Tabs } from "antd";
import { useMemo, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MMNavigationRoutes from "../../utils/navigationRoutes";

const VolunteeringFormPage: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  const schemaIndividual = "MM Volunteers Individual";
  const schemaOrganization = "MM Volunteers Organization";

  const formIndividual = useMemo(() => createForm({}), []);
  const formOrganization = useMemo(() => createForm({}), []);
  const formIndividualRef = useRef<{ handleSave: () => Promise<void> }>(null);
  const formOrganizationRef = useRef<{ handleSave: () => Promise<void> }>(null);

  return (
    <>
      <PageHeader
        className="custom-page-header"
        title={id ? "Edit Volunteering" : "Add Volunteering"}
        onBack={() => navigate("/mm" + MMNavigationRoutes.VOLUNTEERING_LIST)}
      />

      <Tabs
        items={[
          {
            key: "1",
            label: "Individual",
            children: (
              <>
                <SchemaFormAutoSubmit
                  form={formIndividual}
                  schemaName={schemaIndividual}
                  recordId={id}
                  ref={formIndividualRef}
                />
                <div className="flex gap-4">
                  <Button
                    type="primary"
                    onClick={() => {
                      formIndividualRef.current?.handleSave();
                      navigate("/mm" + MMNavigationRoutes.VOLUNTEERING_LIST);
                    }}
                  >
                    Save
                  </Button>
                </div>
              </>
            ),
          },
          {
            key: "2",
            label: "Organization",
            children: (
              <>
                <SchemaFormAutoSubmit
                  form={formOrganization}
                  schemaName={schemaOrganization}
                  recordId={id}
                  ref={formOrganizationRef}
                />
                <div className="flex gap-4">
                  <Button
                    type="primary"
                    onClick={() => {
                      formOrganizationRef.current?.handleSave();
                      navigate("/mm" + MMNavigationRoutes.VOLUNTEERING_LIST);
                    }}
                  >
                    Save
                  </Button>
                </div>
              </>
            ),
          },
        ]}
      />
    </>
  );
};

export default VolunteeringFormPage;
